import { Col, Form, Input, message, Modal, Row, Select, Space } from "antd";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as CheckFilled } from "@src/assets/CN/svg/check-filled.svg";
import { ReactComponent as CheckEmpty } from "@src/assets/CN/svg/check-empty.svg";
import { ReactComponent as BlackCall } from "@src/assets/CN/svg/black-call.svg";
import { ReactComponent as CaretDown } from "@src/assets/CN/svg/caret-down-small.svg";
import { ReactComponent as Close } from "@src/assets/CN/svg/close.svg";
import { addUserContactCN } from "@src/Api/CN";
import { useTranslation } from "react-i18next";
import CNEnum from "@src/Locales/Constants/CNEnum";
import i18n from "@src/Basic/Language/i18n";
import { Popup } from "antd-mobile";
import useContactOpts from "@src/Hooks/CN/useContactOpts";
import {
  FieldCompanyName,
  FieldFirstName,
  FieldAreaCode,
  FieldPhoneNumber,
  FieldEmail,
  FieldCountry,
  FieldContactAddress,
  FieldBusinessType,
  FieldChainStatus,
  FieldOpeningStatus,
  FieldChannelTypeOpts,
  FieldObtainServiceContent,
} from "./FormItem";
import styles from "./index.module.less";
import _ from "lodash";

export default function (props: any) {
  const { isOpen, handleIsOpen } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const { chainOptions, businessTypeOptions, AreaCode, businessStatusOpts, understandChannels } =
    useContactOpts();

  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const values = await form.validateFields();
      addUserContactCN(values).then((res) => {
        message.success(t(CNEnum.submitSuccess), 1.5);
        handleIsOpen(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    form.setFieldsValue({
      // 设置表单初始值
      chainStatus: "CHAIN",
      openingStatus: "BUSINESS",
    });
  }, [form]);

  return (
    <Popup
      className={styles.MobileConcatModal}
      visible={isModalOpen}
      onMaskClick={() => {
        handleIsOpen(false);
      }}
      bodyStyle={{
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
      }}
    >
      <div className={`${styles.titleWrap} flex items-center justify-between`}>
        <div></div>
        <h2 className={styles.title}>联系</h2>
        <Close
          onClick={() => {
            handleIsOpen(false);
          }}
        />
      </div>
      <Form form={form} layout="vertical">
        <FieldCompanyName />
        <FieldFirstName />
        <Row>
          <Col span={8}>
            <FieldAreaCode />
          </Col>
          <Col span={16}>
            <FieldPhoneNumber />
          </Col>
        </Row>
        <FieldEmail />
        <FieldCountry />
        <FieldContactAddress />
        {FieldBusinessType(businessTypeOptions)}
        {FieldChainStatus(chainOptions)}
        {FieldOpeningStatus(businessStatusOpts)}
        {FieldChannelTypeOpts(understandChannels)}
        <FieldObtainServiceContent />
      </Form>
      <div className={styles.btnWrap}>
        <div className={`${styles.submitBtn} cursor-pointer`} onClick={handleSubmit}>
          {t(CNEnum.submit)}
        </div>
      </div>
    </Popup>
  );
}
